document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.slider');

  sliders.forEach(function (slider) {
    let isDown = false;
    let startX;
    let scrollLeft;
    let moved = false;

    slider.style.cursor = 'grab';

    slider.addEventListener('mousedown', function (e) {
      isDown = true;
      moved = false;
      slider.style.cursor = 'grabbing';
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', function () {
      isDown = false;
      slider.style.cursor = 'grab';
    });

    slider.addEventListener('mouseup', function () {
      isDown = false;
      slider.style.cursor = 'grab';
    });

    slider.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      moved = true;
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5;
      slider.scrollLeft = scrollLeft - walk;
    });

    slider.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  });
});